export type ValueFormatter = (value: number, seriesKey?: string) => string

interface TooltipEntry {
  dataKey?: string | number
  name?: string | number
  value?: number | string
  color?: string
}

interface BBTooltipProps {
  active?: boolean
  payload?: TooltipEntry[]
  label?: string | number
  valueFormat?: ValueFormatter
  labelFormat?: (label: string | number) => string
}

export function BBTooltipContent({
  active,
  payload,
  label,
  valueFormat,
  labelFormat,
}: BBTooltipProps) {
  if (!active || !payload?.length) return null
  return (
    <div className="rounded-md border border-border bg-popover px-3 py-2 text-xs shadow-md">
      {label !== undefined && (
        <div className="mb-1 font-medium text-popover-foreground">
          {labelFormat ? labelFormat(label) : String(label)}
        </div>
      )}
      <div className="space-y-0.5">
        {payload.map(entry => (
          <div key={String(entry.dataKey)} className="flex items-center gap-2">
            <span
              className="inline-block h-2 w-2 rounded-full"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-muted-foreground">{entry.name}</span>
            <span className="ml-auto pl-3 font-mono font-medium text-popover-foreground">
              {typeof entry.value === 'number' && valueFormat
                ? valueFormat(entry.value, String(entry.dataKey))
                : String(entry.value ?? '—')}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
